import { render, staticRenderFns } from "./Kiosks.vue?vue&type=template&id=378dc12c&scoped=true&"
import script from "./Kiosks.vue?vue&type=script&lang=js&"
export * from "./Kiosks.vue?vue&type=script&lang=js&"
import style0 from "./Kiosks.vue?vue&type=style&index=0&id=378dc12c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378dc12c",
  null
  
)

export default component.exports